import { Skeleton } from 'components/widgets/skeleton';

export default function SkeletonTextLabel() {
  return (
    <Skeleton
      css={{ height: 16, mr: 4, my: 4, width: 80, '@md': { width: 120 } }}
    />
  );
}
